.section {
    padding: 0;
}

.stickySearch {
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--exo-color-background);
    padding-bottom: var(--exo-spacing-x-small);
}

.heading {
    margin: 0 0 var(--exo-spacing-medium);
}

.track {
    margin-top: var(--exo-spacing-medium);
}
